'use strict';

import angular from 'angular';
import SupportStagesController from './controller/supportStages';
import SupportStageSelectController from './controller/supportStageSelect';
import SupportStageModalCreateController from './controller/supportStageModalCreate';
import SupportStageTableDirective from './directive/supportStagesTable';
import SupportStageService from './service/supportStage';

/**
 * @author Maxim Seredkin
 */
export default angular.module('investmentProject.supportStage', [])
    .controller('SupportStagesController', SupportStagesController)
    .controller('SupportStageSelectController', SupportStageSelectController)
    .controller('SupportStageModalCreateController', SupportStageModalCreateController)
    .directive('supportStageTable', SupportStageTableDirective)
    .factory('SupportStageService', SupportStageService)
    .name;
